import {
  FormKey,
  useLoaderData,
} from '~/app/features/crew/return-summary/returnSummary';
import Badge from '~/components/Badge';
import RadioGroup, {
  ButtonOption,
} from '~/components/form-controls/RadioGroup';
import { ResolutionMethodLabels } from '~/utils/constants';
import ReturnSummaryDisclosure from './ReturnSummaryDisclosure';

function CreditSelectionRadioGroup() {
  const {
    creditMethod: {
      offered: offeredCreditMethods,
      selected: selectedCreditMethod,
    },
    currencyFormatter,
    credits: { sections: creditSections },
  } = useLoaderData();

  const incentive =
    creditSections.find((section) => section.type === 'INCENTIVE')?.amount ?? 0;

  return (
    <RadioGroup label="Refund Method" showLabel={false}>
      <div className="flex flex-col gap-2">
        {offeredCreditMethods.map(({ type: method, label, description }) => (
          <ButtonOption
            key={method}
            required
            name={FormKey.creditMethod}
            value={method}
            defaultChecked={selectedCreditMethod === method}
            aria-labelledby={`method-${method}-label`}
            aria-describedby={`method-${method}-description`}
            className="items-start rounded-lg! bg-white p-3 hover:bg-gray-50 [&>input]:mt-1"
          >
            <div className="flex flex-col gap-1 text-sm">
              <div
                id={`method-${method}-label`}
                className="flex items-center gap-2 font-medium text-gray-900"
              >
                {label}
                {incentive > 0 && method === 'Gift_Card' && (
                  <Badge variant="success">
                    {currencyFormatter(incentive)} Incentive
                  </Badge>
                )}
              </div>
              <p id={`method-${method}-description`} className="text-gray-500">
                {description}
              </p>
            </div>
          </ButtonOption>
        ))}
      </div>
    </RadioGroup>
  );
}

export default function RefundSelection() {
  const {
    creditMethod: { selected: selectedCreditMethod, offered: offeredMethods },
    outstandingBalance,
  } = useLoaderData();

  if (
    offeredMethods.length === 0 ||
    !outstandingBalance ||
    outstandingBalance.total > 0
  ) {
    return null;
  }

  if (offeredMethods.length === 1 && selectedCreditMethod) {
    return (
      <input
        data-testid="default-refund-method"
        type="hidden"
        name={FormKey.creditMethod}
        value={selectedCreditMethod}
      />
    );
  }

  return (
    <ReturnSummaryDisclosure
      label="Selections"
      value={
        selectedCreditMethod ?
          ResolutionMethodLabels[selectedCreditMethod]
        : '1 Remaining'
      }
      defaultOpen
    >
      <CreditSelectionRadioGroup />
    </ReturnSummaryDisclosure>
  );
}
